import { AlertFormContext } from 'components/ChartAlert/Contexts/AlertFormContext';
import { useDeepMemo } from 'hooks/helpers';
import { Alert } from 'lib/alert/models';
import React, { Dispatch, SetStateAction, useCallback, useState } from 'react';

type Props = {
    children: JSX.Element;
    setHasChanges: Dispatch<SetStateAction<boolean>>;
    defaultValues?: Partial<Alert> | null;
    defaultActiveStep?: number;
};

const AlertFormProvider = ({
    children,
    setHasChanges,
    defaultValues = null,
    defaultActiveStep = 0,
}: Props): JSX.Element => {
    const [alert, setAlert] = useState<Partial<Alert>>(defaultValues ?? {});
    const [activeStep, setActiveStep] = useState(defaultActiveStep);

    const setAlertAndNotifyChanges = useCallback(
        (newAlert: Partial<Alert>) => {
            setHasChanges(true);
            setAlert(newAlert);
        },
        [setAlert, setHasChanges],
    );

    const alertState = useDeepMemo(
        () => ({
            alert,
            setAlert: setAlertAndNotifyChanges,
            activeStep,
            setActiveStep,
        }),
        [alert, activeStep, setAlertAndNotifyChanges, setActiveStep],
    );

    return (
        <AlertFormContext.Provider value={alertState}>
            {children}
        </AlertFormContext.Provider>
    );
};

export default AlertFormProvider;
